export default __webpack_public_path__ + "static/feature-discovery-start-1acffdca3afb93393daee3d1df5cf1e1.png";